<div (clickOutside)="timepickerVisible = false; onBlur()">
  <div class="floating-input-wrapper"
       [class.focused]="isFocused"
       [class.has-value]="hasValue"
       [class.disabled]="disabled">
    <div class="floating-input-container">
      <input 
        class="floating-input"
        [class]="ngClass"
        name="{{field.code}}"
        id="{{field.code}}"
        autocomplete="off"
        (ngModelChange)="onInputChange($event)"
        [(ngModel)]="displayValue"
        [disabled]="disabled"
        (focus)="onFocus()"
        (blur)="onBlur()"
        placeholder=" "
      />
      <label class="floating-label" [class.floating]="isFocused || hasValue">
        <img
          src="assets/icons/required-asterisk.svg"
          *ngIf="required"
          [attr.alt]="'alt.requiredField' | translate"
        >
        {{ label || placeholder }}
        <!-- <span class="required-asterisk" *ngIf="required"></span> -->
      </label>
    </div>
  </div>
  <div class="sc-timepicker-container" *ngIf="timepickerVisible">
    <div class="sc-timepicker-wrapper">
      <ngb-timepicker class="sc-timepicker"
                      [(ngModel)]="time" (ngModelChange)="onChange($event)"></ngb-timepicker>
    </div>
  </div>
</div>
